import { render, staticRenderFns } from "./week.vue?vue&type=template&id=bbfa74f2"
import script from "./week.ts?vue&type=script&lang=ts&external"
export * from "./week.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports